module.exports = __webpack_public_path__ + "img/google-play-badge.bbb2dd4e.svg";